import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global Lenis smooth-scroll manager.
 * Uses Lenis 1.3+ with autoRaf so browser handles the render loop.
 * Keeps native `window.scrollY` in sync, so `position: fixed` elements
 * and Playwright's `window.scrollTo` continue to work correctly.
 */
export default function useLenis() {
  useEffect(() => {
    // Bail out if any consumer already installed a Lenis instance.
    if (window.__kn_lenis__) return;

    const lenis = new Lenis({
      autoRaf: true,
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
      // Do NOT set a wrapper — Lenis will scroll the window natively.
    });
    window.__kn_lenis__ = lenis;

    // Anchor click support (hash links, e.g. #services)
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href === "#" || href.length < 2) return;
      const el = document.querySelector(href);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -80 });
    };
    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
      lenis.destroy();
      delete window.__kn_lenis__;
    };
  }, []);
}
